import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Boton from '../Components/Atoms/Boton';
import TablaSolicitudesCompra from '../Components/Organisms/TablaSolicitudesCompra';
import { ReconciliationOutlined } from '@ant-design/icons';
import clienteAxios from '../Utils/clienteAxios';
import decodeToken from '../Utils/decodeToken';
import { isWorkflowRole } from '../Utils/workflowRole';
import { Tabs } from 'antd';
import Swal from 'sweetalert2';

const SolicitudesGasto = () => {
  const [requestsManager, setRequestsManager] = useState([]);
  const [adminRequests, setAdminRequests] = useState([]);
  const [myRequests, setMyRequests] = useState([]);
  const [shopping, setShopping] = useState([]);
  const [loadingManager, setLoadingManager] = useState(true);
  const [loadingAdmin, setLoadingAdmin] = useState(true);
  const [loadingMine, setLoadingMine] = useState(true);
  const [loadingShopping, setLoadingShopping] = useState(true);
  let decodedToken = decodeToken(localStorage.getItem('token'));

  const allowedRoles = [
    'equipo_administracion',
    'equipo_almacen',
    'equipo_calidad',
    'equipo_compras',
    'equipo_direccion',
    'equipo_diseno_operativo',
    'equipo_importaciones',
    'equipo_logistica',
    'equipo_mesa_control',
    'equipo_produccion',
    'equipo_recursos_humanos',
    'equipo_ti',
    'equipo_ventas_bh',
    'equipo_ventas_pl',
    'sin_definir',
    'Super_Admin',
    'marketing_pl'
  ];

  const userRole = decodedToken?.role?.name;
  const isIntegral = isWorkflowRole(userRole);

  // Cada lista se pide por separado: la que llega primero se muestra sin esperar a las demás.
  useEffect(() => {
    let avisado = false;
    const avisarError = (error) => {
      if (avisado) return;
      avisado = true;
      Swal.fire({
        icon: 'error',
        title: error.response?.data?.message,
        confirmButtonText: 'Aceptar'
      });
    };
    const cargar = (peticion, guardar, terminar) =>
      peticion
        .then((respuesta) => guardar(respuesta.data.spents.reverse()))
        .catch(avisarError)
        .finally(() => terminar(false));

    cargar(
      clienteAxios.get('caja-chica/solicitudes-de-compra/por-departamento/ver'),
      setRequestsManager,
      setLoadingManager
    );
    cargar(clienteAxios.get('/caja-chica/mis-ordenes'), setMyRequests, setLoadingMine);
    cargar(clienteAxios.get('/caja-chica/ordenes-comprador'), setShopping, setLoadingShopping);
    cargar(
      clienteAxios.get('/caja-chica/administrador/solicitudes-de-compra/ver'),
      setAdminRequests,
      setLoadingAdmin
    );
  }, []);

  return (
    <>
      <div className="title-content-between solicitudes-encabezado">
        <h1 className="mb-2 mr-5">Solicitudes de gasto</h1>
        {userRole === 'administrator' ||
        userRole === 'Super_Admin' ||
        userRole === 'caja_chica' ||
        userRole === 'Adquisiciones' ||
        isIntegral ? (
          <Link to="/reporte-general">
            <Boton type="secondary" icon={<ReconciliationOutlined />}>
              Reporte General
            </Boton>
          </Link>
        ) : null}
        <Link to="/nueva-solicitud">
          <Boton type="primary">Nueva Solicitud</Boton>
        </Link>
      </div>
      {isIntegral ? (
        <div>
          <Tabs
            defaultActiveKey="1"
            items={[
              {
                key: '1',
                label: `Solicitudes Por Aprobar`,
                children: (
                  <>
                    <p className="solicitudes-descripcion">
                      Solicitudes pendientes de aprobar, tanto del jefe directo como del
                      administrador. Con tu rol puedes autorizarlas directamente.
                    </p>
                    <TablaSolicitudesCompra data={adminRequests} loading={loadingAdmin} />
                  </>
                )
              },
              {
                key: '2',
                label: `Solicitudes De Adquisición`,
                children: (
                  <>
                    <p className="solicitudes-descripcion">
                      Solicitudes ya aprobadas, listas para su compra y entrega.
                    </p>
                    <TablaSolicitudesCompra data={shopping} loading={loadingShopping} />
                  </>
                )
              },
              {
                key: '3',
                label: `Mis Solicitudes`,
                children: (
                  <>
                    <TablaSolicitudesCompra data={myRequests} loading={loadingMine} />
                  </>
                )
              }
            ]}
          />
        </div>
      ) : userRole === 'administrator' || userRole === 'Super_Admin' ? (
        <div>
          <Tabs
            defaultActiveKey="1"
            items={[
              {
                key: '1',
                label: `Solicitudes Por Aprobar`,
                children: (
                  <>
                    <p className="solicitudes-descripcion">
                      Solicitudes que ya fueron aprobadas o rechazadas por el jefe directo.
                    </p>
                    <TablaSolicitudesCompra data={adminRequests} loading={loadingAdmin} />
                  </>
                )
              },
              {
                key: '2',
                label: `Mis Solicitudes`,
                children: (
                  <>
                    <TablaSolicitudesCompra data={myRequests} loading={loadingMine} />
                  </>
                )
              }
            ]}
          />
        </div>
      ) : allowedRoles.includes(userRole) ? (
        <div>
          <TablaSolicitudesCompra data={myRequests} loading={loadingMine} />
        </div>
      ) : userRole === 'caja_chica' || userRole === 'Adquisiciones' ? (
        <div>
          <Tabs
            defaultActiveKey="1"
            items={[
              {
                key: '1',
                label: `Solicitudes De Adquisición`,
                children: (
                  <>
                    <p className="solicitudes-descripcion">
                      Solicitudes aprobadas por el administrador, listas para su compra.
                    </p>
                    <TablaSolicitudesCompra data={shopping} loading={loadingShopping} />
                  </>
                )
              },
              {
                key: '2',
                label: `Mis Solicitudes`,
                children: (
                  <>
                    <TablaSolicitudesCompra data={myRequests} loading={loadingMine} />
                  </>
                )
              }
            ]}
          />
        </div>
      ) : userRole === 'manager' ? (
        <div>
          <Tabs
            defaultActiveKey="1"
            items={[
              {
                key: '1',
                label: `Solicitudes Por Aprobar`,
                children: (
                  <>
                    <p className="solicitudes-descripcion">Solicitudes de tu área.</p>
                    <TablaSolicitudesCompra data={requestsManager} loading={loadingManager} />
                  </>
                )
              },
              {
                key: '2',
                label: `Mis Solicitudes`,
                children: (
                  <>
                    <TablaSolicitudesCompra data={myRequests} loading={loadingMine} />
                  </>
                )
              }
            ]}
          />
        </div>
      ) : null}
    </>
  );
};
export default SolicitudesGasto;
